import { render } from "./Automation.vue?vue&type=template&id=4cf40910&scoped=true"
import script from "./Automation.vue?vue&type=script&lang=js"
export * from "./Automation.vue?vue&type=script&lang=js"

import "./Automation.vue?vue&type=style&index=0&id=4cf40910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf40910"]])

export default __exports__